import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AppConfig } from './app.config';

@Injectable({
  providedIn: 'root'
})
export class MockService {

  constructor(public http: HttpClient, public AppConfig: AppConfig) { }

    getOtp(email: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': 'f61a6f71-2bc4-4b50-8fe0-e2694671207f',
        'secret': '7796b364-02d2-42db-990b-bc1973b68211',
         
      })
    };

    return this.http.post('https://adminapi.iqmock.iquanta.in/business/otp/' + email, {}, httpOptions)
      .pipe(map((response: any) => response));
  }

  resetAccount(email: any, id:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'secret':'667e6a7d3a9e0fc886a4cfa5667e6a7d3a9e0fc886a4cfa5',
        'token':'650445c6fc904d452998918c650445c6fc904d452998918c',
         
      })
    };

    return this.http.delete('https://api.iverse.iquanta.in/api/student/v1/verify/reset/'+email+'/' + id, httpOptions)
      .pipe(map((response: any) => response));
  }

  updateMockData(email: any, id:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'secret':'667e6a7d3a9e0fc886a4cfa5667e6a7d3a9e0fc886a4cfa5',
        'token':'650445c6fc904d452998918c650445c6fc904d452998918c',
         
      })
    };

    return this.http.patch('https://api.iverse.iquanta.in/api/student/v1/verify/update/email/' + id, { email: email}, httpOptions)
      .pipe(map((response: any) => response));
  }

   courseDetails(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
 
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'course?course_id=' + id, httpOptions)
      .pipe(map((response: any) => response));
  }

    getAllCourses() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
 
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'course', httpOptions)
      .pipe(map((response: any) => response));
  }

   getPagewiseCourses(type: any, page: any, year: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
 
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'CoursesGetBasedOnCategoryAndYear?page_type=' + page + '&category_name=' + type + '&year=' + year, httpOptions)
      .pipe(map((response: any) => response));
  }

   getMockStatus(reqObj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': 'f61a6f71-2bc4-4b50-8fe0-e2694671207f',
        'secret': '7796b364-02d2-42db-990b-bc1973b68211',
         
      })
    };

    return this.http.get('https://adminapi.iqmock.iquanta.in/business/mockstatus/' + reqObj.uid + '/' + reqObj.id, httpOptions)
      // return this.http.get('https://adminapi.iverse.iquanta.in/platform/v1/connect/test/status/'+reqObj.id+'/'+reqObj.uid, httpOptions)
      .pipe(map((response: any) => response));
  }

  getXatStatus(reqObj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': 'f61a6f71-2bc4-4b50-8fe0-e2694671207f',
        'secret': '7796b364-02d2-42db-990b-bc1973b68211',
         
      })
    };

    return this.http.get('https://adminapi.iverse.iquanta.in/platform/v1/connect/status/' + reqObj.id + '/' + reqObj.uid, httpOptions)
      .pipe(map((response: any) => response));
  }

  getSectionalMockStatus(reqObj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': 'f61a6f71-2bc4-4b50-8fe0-e2694671207f',
        'secret': '7796b364-02d2-42db-990b-bc1973b68211',
         
      })
    };

    return this.http.get('https://adminapi.iqmock.iquanta.in/business/sectionalmockstatus/' + reqObj.uid + '/' + reqObj.id, httpOptions)
      .pipe(map((response: any) => response));
  }

    getTestMockStatus(reqObj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': 'f61a6f71-2bc4-4b50-8fe0-e2694671207f',
        'secret': '7796b364-02d2-42db-990b-bc1973b68211',
         
      })
    };

    // return this.http.get('https://adminapi.iqmock.iquanta.in/business/mockstatus/' + reqObj.uid + '/' + reqObj.id, httpOptions)
      return this.http.get('https://adminapi.iverse.iquanta.in/platform/v1/connect/test/status/'+reqObj.id+'/'+reqObj.uid, httpOptions)
      .pipe(map((response: any) => response));
  }

   getProfile(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'user_get', httpOptions)
      .pipe(map((response: any) => response));
  }

   paymock(token:any, reqData:any, id:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.post(this.AppConfig.LOGIN_ENDPOINT + 'MocksCourseGPost', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

    getProductReferalList(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT1 + 'ProductReferralAmountlist', httpOptions)
      .pipe(map((response: any) => response));
  }

    getReferalList() {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      };
  
      return this.http.get(this.AppConfig.API_ENDPOINT1 + 'ReferralAmountlist', httpOptions)
        .pipe(map((response: any) => response));
    }

     getCustomCourseReferral(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT1 + 'CustomCourseReferralAmountlist', httpOptions)
      .pipe(map((response: any) => response));
  }

   addCRMLead(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': '6669ac7eeb6f363a778463e0',
        "orgid": reqData.orgId,
        "uid":  reqData.uid,
      })
    };
      return this.http.post('https://crm-api-prod.iquanta.in/api/v1/org/leads/details/single/v2/create', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

}